export const B = {
  FREE_TRIAL: '/b/free-trial/',
  YEARLY_PROMO: '/b/yearly-promo/',
  YEARLY: '/b/yearly/',
  MONTHLY: '/b/monthly/',
  FREE_TRIAL_STUDIO_AI_YEARLY: '/b/free-trial-aistudio/',
}
